import 'kfone-component-library/font-faces.css';
import 'kfone-component-library/style.css';
import { SnackbarProvider } from 'notistack';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './i18n';

// Provided by Vite define in vite.config.*
declare const __MODULE_NAME__: string;

const basename = (() => {
  try {
    if (typeof __MODULE_NAME__ !== 'undefined') {
      return __MODULE_NAME__ === 'kfone-kfnr-cms-spoke' ? '/cms-spoke' : '/cms';
    }
  } catch (e) {
    // noop, fallback below
  }
  return '/cms';
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <SnackbarProvider
        maxSnack={3}
        preventDuplicate
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </StrictMode>,
);
